var userAgent = navigator.userAgent.toLowerCase()

function flagAgent() {
    if (userAgent.indexOf('chrome') !== -1) {
        // 当前浏览器是谷歌 Chrome
        return 'chrome'
    } else if (userAgent.indexOf('360se') !== -1 || userAgent.indexOf('360ee') !== -1) {
        // 当前浏览器是 360 极速/EE
        return '360se'
    } else if (userAgent.indexOf('edge') !== -1) {
        // 当前浏览器是 Edge
        return 'edge'
    } else if (userAgent.indexOf('firefox') !== -1) {
        // 当前浏览器是火狐 Firefox
        return 'firefox'
    } else {
        // 其他浏览器
        return 'other'
    }
}

export const useFitScreen = (id) => {
    const fitScreen = () => {
        const body = document.documentElement
        const bodyWidth = body.clientWidth
        const bodyHeight = body.clientHeight

        const realRatio = bodyWidth / bodyHeight
        const designRatio = 16 / 9
        const scaleRate = realRatio > designRatio ? bodyHeight / 1080 : bodyWidth / 1920

        const app = document.querySelector(id)
        const dom = document.getElementById('viewContentHeight')

        app &&
        (app.style.transformOrigin = 'left top') &&
        //@ts-ignore
        (app.style.zoom = scaleRate) &&
        (app.style.transform = ` translateX(-50%) translate3d(0, 0, 0)`) &&
        (app.style.position = 'fixed') &&
        // (app.style.height = '100%') &&
        (app.style.width = `${bodyWidth / scaleRate}px`)
        if (app) {
            switch (flagAgent()) {
                case 'chrome':
                    app.style.left = '50%'
                    app.style.height = '100%'
                    app.setAttribute('zoom', `${scaleRate}`)
                    break;
                //其他浏览器暂时按火狐处理
                case '360se':
                case 'edge':
                case 'firefox':
                    app.style.height = dom.offsetHeight / scaleRate + 'px'
                    app.style.transform = ` scale(${scaleRate})`
                    break;
            }
        }
    }
    window.onresize = () => fitScreen()

    fitScreen()
}
